var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonS3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1418067976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.373 23.6831L2.57812 26.4081V5.5498L16.373 8.21647V23.6831Z",
    fill: "#E05243"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 23.7169L29.4223 26.4086L29.4323 26.3836V5.58359L29.4223 5.55859L16 8.25026V23.7253",
    fill: "#8C3123"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M16 0V8.06667L21.8402 9.26667V2.41667L16 0ZM29.4223 5.55V26.4083L32 25.3417V6.61667L29.4223 5.55ZM16 11.975V20.0583L21.8402 19.4333V12.5833L16 11.975ZM21.8402 22.7333L16 23.9333V32L21.8402 29.5833V22.7333Z",
    fill: "#E05243"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a_2",
    d: "M16 32V23.9333L10.1598 22.7333V29.5833L16 32ZM2.57772 26.45V5.59167L0 6.65833V25.3833L2.57772 26.45ZM16 20.025V11.9417L10.1598 12.5667V19.4167L16 20.025ZM10.1598 9.26667L16 8.06667V0L10.1598 2.41667V9.26667Z",
    fill: "#8C3123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.8405 9.26614L16.0003 10.1578L10.1602 9.26614L15.9902 8.00781L21.8606 9.26614",
    fill: "#5E1F18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.8405 22.7325L16.0003 21.8408L10.1602 22.7325L15.9902 24.0742L21.8606 22.7325",
    fill: "#F2B0A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonS3Icon);
export default __webpack_public_path__ + "static/media/amazon-s3-icon.e5fb6b02717fad889ef03545a7df8b59.svg";
export { ForwardRef as ReactComponent };